module.exports = __webpack_public_path__ + "images/gavdos/anendyk-logo.png";